module.exports = __webpack_public_path__ + "images/emoji/bouquet.920e8d66980a4de41294.png";